import { createFileRoute } from "@tanstack/react-router";
import { SilverPage, silverRatesQO } from "@/components/SilverPage";
import { buildAliasHead } from "@/lib/alias-routes";

const TITLE = "Live Silver Rate in Pakistan Today — Chandi Ka Rate Per Tola & 10 Gram";
const DESC = "Today's live chandi (silver) rate in Pakistan — per tola, per 10 gram, per gram and per kg. Live gold + silver in Pakistan, refreshed every 10 min from international XAG/XAU spot + USD/PKR.";

export const Route = createFileRoute("/silver-rate-pakistan")({
  head: () => buildAliasHead({ title: TITLE, description: DESC, path: "/silver-rate-pakistan" }),
  loader: ({ context }) => context.queryClient.ensureQueryData(silverRatesQO),
  component: () => (
    <SilverPage
      country="pakistan"
      title="Today's Live Chandi (Silver) Rate in Pakistan"
      intro="Live silver / chandi rate in Pakistan — recalculated every 10 minutes from international XAG spot price and today's USD/PKR rate, sitting alongside our live 24K, 22K, 21K & 18K gold rate. Per tola, per 10 gram, per gram and per kilogram, with a 6-month silver chart and one-tap jump to the today's gold rate in Pakistan."
    />
  ),
});